var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDominicanRepublic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81934 322.783C32.4573 410.486 101.514 479.544 189.218 503.182V322.783H8.81934Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.217 8.81897C101.514 32.456 32.4563 101.514 8.81934 189.217H189.218V8.81897H189.217Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.181 189.217C479.544 101.514 410.486 32.456 322.783 8.81897V189.218H503.181V189.217Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.783 503.181C410.486 479.543 479.544 410.486 503.182 322.782H322.783V503.181Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.783 256C322.783 292.884 292.884 322.783 256 322.783C219.117 322.783 189.217 292.884 189.217 256C189.217 219.116 256 189.217 256 189.217C256 189.217 322.783 219.116 322.783 256Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.217 256C189.217 219.116 219.117 189.217 256 189.217C292.884 189.217 322.783 219.116 322.783 256",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.435 222.609V264.348C218.435 285.095 235.253 301.913 256 301.913C276.747 301.913 293.565 285.095 293.565 264.348V222.609H218.435Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDominicanRepublic);
export default __webpack_public_path__ + "static/media/dominicanRepublic.72150027bd8e4a7153016f2bd33fd77e.svg";
export { ForwardRef as ReactComponent };